<div class="input-element">
    <label><strong>Edit Instruction</strong></label>
    <p class="description">Describe what you aim for below</p>
    <textarea [formControl]="textControl" rows="3" class="w-100" placeholder="E.g. 'Please name the phase ... and make it 2 weeks long. Include three milestones ... and consider the risk ... .'"
        tabindex="0"></textarea>
</div>

<button class="btn btn-primary input-element button-bottom w-100" (click)="onSubmit()">
    Regenerate phase
</button>